// Inspi Viewer Component
export const SET_VERSION = (state, version) => { state.version = version }
export const SET_USER = (state, user) => { state.user = user }
export const SET_TOKEN = (state, token) => { state.token = token }

// Product
export const SET_PRODUCT_LOADED = (state, isLoaded) => { state.productLoaded = isLoaded }
export const SET_PRODUCT_NAME = (state, name) => { state.productName = name }
export const SET_PRODUCT_PRICE = (state, price) => { state.productPrice = price }

// UI
export const SET_MENU_DISPLAYED = (state, isDisplayed) => { state.menuDisplayed = isDisplayed }
export const SET_DIVIDERS_DISPLAYED = (state, isDisplayed) => { state.dividersDisplayed = isDisplayed }
export const SET_COLLECTION_DISPLAYED = (state, isDisplayed) => { state.collectionDisplayed = isDisplayed }

// Header
export const SET_HEADER_ALIGNMENT = (state, alignment) => { state.headerAlignment = alignment }
export const SET_PRODUCT_NAME_DISPLAYED = (state, isDisplayed) => { state.productNameDisplayed = isDisplayed }
export const SET_PRODUCT_PRICE_DISPLAYED = (state, isDisplayed) => { state.productPriceDisplayed = isDisplayed }

// Gamepad
export const SET_GAMEPAD_BUTTONS_COLOR = (state, color) => { state.gamepadButtonsColor = color }
export const SET_AR_BUTTON_DISPLAYED = (state, isDisplayed) => { state.arButtonDisplayed = isDisplayed }
export const SET_RESET_BUTTON_DISPLAYED = (state, isDisplayed) => { state.resetButtonDisplayed = isDisplayed }
export const SET_DIMENSIONS_BUTTON_DISPLAYED = (state, isDisplayed) => { state.dimensionsButtonDisplayed = isDisplayed }
export const SET_SCREENSHOT_BUTTON_DISPLAYED = (state, isDisplayed) => { state.screenshotButtonDisplayed = isDisplayed }
export const SET_PROJECT_BUTTON_DISPLAYED = (state, isDisplayed) => { state.projectButtonDisplayed = isDisplayed }

// Screenshot
export const SET_FRONT_SCREENSHOT_ENABLED = (state, isEnabled) => { state.frontScreenshotEnabled = isEnabled }

// Project
export const SET_PROJECT_CREATING = (state, isCreating) => { state.projectCreating = isCreating }

// AR
export const SET_AR_LOADING = (state, isLoading) => { state.arLoading = isLoading }

// Glances
export const SET_GLANCED_OPTIONS_ITEM = (state, item) => { state.glancedOptionsItem = item }
